import { render, staticRenderFns } from "./PreviewAnnouncement.vue?vue&type=template&id=139e3bb6&scoped=true&"
import script from "./PreviewAnnouncement.vue?vue&type=script&lang=js&"
export * from "./PreviewAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./PreviewAnnouncement.vue?vue&type=style&index=0&id=139e3bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139e3bb6",
  null
  
)

export default component.exports